module.exports = __webpack_public_path__ + "img/logo-alogo-blanc.907d579d.png";